import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDimension = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 17"
    {...props}
  >
    <path d="M7.15 8.435v8.29a1.7 1.7 0 0 1-.385-.167l-5.92-3.515A1.73 1.73 0 0 1 0 11.559V4.755q0-.215.052-.42zm8.091-4.095q.05.202.052.415v6.804c0 .609-.322 1.173-.846 1.484l-5.919 3.515q-.18.106-.378.165V8.435zM6.861.19a1.73 1.73 0 0 1 1.572 0l5.92 3.028q.209.108.377.262L7.65 7.568.564 3.478q.168-.154.376-.26z" />
  </svg>
);
export default SvgDimension;
